// extracted by mini-css-extract-plugin
export default {"root":"FullPageSpinner_root__k+oKA"};